import axios from 'src/api/client/axios'
import { ChannelHeritageList, DateDataList } from 'src/api'
import { AdvancedChannelHeritageList } from 'src/api/models/advancedChannelHeritageList.model'

export interface ApiSaveDataChannelHeritageListResponse {
  ok: boolean
}

export interface ApiSaveDataChannelHeritageListData {
  percentTypeId: string
  value: string
  channelId: string
  rateId: string
  channelList: string[]
  rateList: string[]
  dateDataList: DateDataList[]
}

export interface ApiSaveDataChannelHeritageParamsData {
  userToken: string
  environmentDataId: string
  channelHeritageList: Omit<AdvancedChannelHeritageList, 'id'>[] | ChannelHeritageList[]
}

export interface ApiSaveDataChannelHeritageParams {
  serverPath: string
  data: ApiSaveDataChannelHeritageParamsData
  controller?: AbortController
}

export const ApiSaveDataChannelHeritage = async ({ serverPath, data, controller }:ApiSaveDataChannelHeritageParams) => {
  const res = await axios.post<ApiSaveDataChannelHeritageListResponse>(`https://${serverPath}/sialdPMS/web/resourcescrossorigin/seasonmanual/savedatachannelheritage`, data, {
    signal: controller?.signal
  })
  return res.data
}
